/* ------------------------------------------------------------------------------
@name: Regex
@description: Indexing all Regex
--------------------------------------------------------------------------------- */

export * from "@variables/Regex";
